export const separateStringIntoHalves = (word: string): string[] => {
    const idx = word.length / 2;
    return [word.substring(0, idx) || '', word.substring(idx) || ''];
};
